import {requestLeadPopupCloudHtml} from "./lead-info-popup-cloud";

const activeRequests = new WeakMap();

/** Share an in-flight read so reopening a lead cannot apply responses out of order. */
export function requestCoordinatedLeadPopupCloudHtml(popupElement, data) {
    if (!popupElement) throw new Error('Lead popup target is unavailable.');
    const active = activeRequests.get(popupElement);
    if (active) return {promise: active, started: false};

    const promise = requestLeadPopupCloudHtml(data).finally(() => {
        if (activeRequests.get(popupElement) === promise) activeRequests.delete(popupElement);
    });
    activeRequests.set(popupElement, promise);
    return {promise, started: true};
}

/** A post-save refresh must read after any request that could predate the save. */
export async function requestFreshLeadPopupCloudHtml(popupElement, data) {
    const active = activeRequests.get(popupElement);
    if (active) {
        try {await active;} catch (error) { /* The new read retries the failed read. */ }
    }
    return requestCoordinatedLeadPopupCloudHtml(popupElement, data).promise;
}
